// extracted by mini-css-extract-plugin
module.exports = {"content":"update-email_content__GTa42","wrapper":"update-email_wrapper__wvMGI"};